const logger = (mode, args) => {
    if (window.location.hostname === 'localhost') {
        mode(...args);
    }
}

const loggerWrapper = {
    info: (...args) => logger(console.info, args),
    warn: (...args) => logger(console.warn, args),
    debug: (...args) => logger(console.debug, args),
    log: (...args) => logger(console.log, args),
    dir: (...args) => logger(console.dir, args),
    error: (...args) => logger(console.error, args),
};

export default loggerWrapper;
